module.exports = __webpack_public_path__ + "static/miu-cs-c6f5f79f40baabcb471e1e4c9b579de7.svg";